import React from "react";

import heroImg from "../../../assets/images/Dietplan-updated/Plan Screen Image /04.webp";

import "./CalorieTrackAndroidSection.css";

const CalorieTrackAndroidSection = () => {
  return (
    <div className="diet-calorie-track-android">
      <div className="diet-calorie-track-android__card">
        <img
          className="diet-calorie-track-android__hero"
          src={heroImg}
          alt="Log your meal and count calorie"
          loading="lazy"
        />
      </div>

      <div className="diet-calorie-track-android__below">
        <div className="diet-calorie-track-android__belowTitle">Calorie Tracking</div>
        <div className="diet-calorie-track-android__belowText">
          Stay on top of your nutrition by making it easy to log the foods you eat and see how many calories you&apos;re
          consuming each day. With a built-in database of meals and ingredients, you can quickly record snacks, drinks,
          and full meals, while the app automatically calculates your totals.
        </div>
      </div>
    </div>
  );
};

export default CalorieTrackAndroidSection;

